import { Tabs } from "antd";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { AddActionOfIndividualnclusion, AddActionOfKeyCondition } from "../DisplayLabelsClass";
import { KeyConditionActions } from "../model";
import ByCondition from "./byCondition";
import ByIndividualInclusion from "./byIndividualInclusion";
import { useIsIndividualInclusionNamingEnabled } from "../common/hooks/IsIndividualInclusionNamingEnabled";

function ManageMembersByAddition({ userGroupUniqueName, setCurrentStepState, setDisplayLabels }) {
  const dispatch = useDispatch();
  const isIndividualInclusionNamingEnabled = useIsIndividualInclusionNamingEnabled();

  const isSpecialConditionChecked = useSelector(
    (rootState: RootState) => rootState.keyCondition.isSpecialConditionChecked
  );

  useEffect(() => {
    if (defaultActiveTab() === "2") {
      setDisplayLabels(new AddActionOfIndividualnclusion(isIndividualInclusionNamingEnabled));
    } else if (defaultActiveTab() === "1") {
      setDisplayLabels(new AddActionOfKeyCondition());
    }
  }, []);

  function defaultActiveTab() {
    return isSpecialConditionChecked ? "2" : "1";
  }

  return (
    <Tabs
      type="editable-card"
      defaultActiveKey={defaultActiveTab()}
      onChange={(activeKey) => {
        dispatch(KeyConditionActions.resetSelectedUser());
        if (activeKey === "1") {
          dispatch(KeyConditionActions.setIsSpecialConditionChecked(false));
          dispatch(KeyConditionActions.setSpecialConditionNode(null));
          setDisplayLabels(new AddActionOfKeyCondition());
        } else if (activeKey === "2") {
          setDisplayLabels(new AddActionOfIndividualnclusion(isIndividualInclusionNamingEnabled));
        }
      }}
      hideAdd
    >
      <Tabs.TabPane tab="Add members by condition" key="1" closable={false}>
        <ByCondition
          userGroupUniqueName={userGroupUniqueName}
          setCurrentStepState={setCurrentStepState}
          setDisplayLabels={setDisplayLabels}
        />
      </Tabs.TabPane>
      <Tabs.TabPane tab="Add member by Name/Emp ID" key="2" closable={false}>
        <ByIndividualInclusion
          setCurrentStepState={setCurrentStepState}
          setDisplayLabels={setDisplayLabels}
          userGroupUniqueName={userGroupUniqueName}
        />
      </Tabs.TabPane>
    </Tabs>
  );
}

export default ManageMembersByAddition;
